'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

require('./ToolButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var ToolButton = function ToolButton(_ref) {
    var icon = _ref.icon,
        text = _ref.text,
        onClickFn = _ref.onClickFn,
        className = _ref.className;

    var textElement = text ? _react2.default.createElement(
        'span',
        { className: 'tool-text' },
        text
    ) : null;
    return _react2.default.createElement(
        _Button2.default,
        { className: (0, _classnames2.default)('ToolButton highlight', className), onClickFn: onClickFn },
        _react2.default.createElement(
            'div',
            { className: 'button-content' },
            icon,
            textElement
        )
    );
};

// Styles
// Lib


ToolButton.propTypes = {
    icon: _propTypes2.default.object,
    text: _propTypes2.default.string,
    onClickFn: _propTypes2.default.func,
    className: _propTypes2.default.string
};

exports.default = ToolButton;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/buttons/ToolButton.js
// module id = 676
// module chunks = 0